import React, { useEffect, useState } from "react";
import { Card, Spinner, Callout } from "@blueprintjs/core";
import { useAuth } from "../../auth/AuthContext";

interface LogMessage {
  role: string;
  content: string;
  created_at: string;
}

export default function ChatLog() {
  const { idToken } = useAuth();
  const [history, setHistory] = useState<LogMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!idToken) {
      setLoading(false);
      return;
    }
    const fetchHistory = async () => {
      try {
        const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "") + "/api";
        const res = await fetch(`${API_BASE}/openai/history`, {
          headers: { Authorization: `Bearer ${idToken}` },
        });
        if (res.ok) {
          setHistory(await res.json());
        } else {
          setError("Failed to load history");
        }
      } catch {
        setError("Failed to load history");
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [idToken, setLoading, setHistory, setError]);

  if (loading) return <Spinner />;
  if (error) return <Callout intent="danger">{error}</Callout>;
  if (history.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>No chat messages recorded.</div>
    );
  }

  const qaPairs: { q: LogMessage; a?: LogMessage }[] = [];
  for (let i = 0; i < history.length; i++) {
    const msg = history[i];
    if (msg.role === "user") {
      qaPairs.push({ q: msg, a: history[i + 1] && history[i + 1].role !== "user" ? history[i + 1] : undefined });
    }
  }

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: "2rem 0" }}>
      {qaPairs.map((p, i) => (
        <Card key={i} style={{ marginBottom: "1rem" }}>
          <details>
            <summary>
              <b>You:</b> {p.q.content}
              <span style={{ marginLeft: 8, fontSize: "0.85em", color: "#888" }}>
                {new Date(p.q.created_at).toLocaleString()}
              </span>
            </summary>
            {p.a && (
              <div style={{ marginTop: 8 }}>
                <b>AI:</b> {p.a.content}
                <div style={{ fontSize: "0.85em", color: "#888" }}>
                  {new Date(p.a.created_at).toLocaleString()}
                </div>
              </div>
            )}
          </details>
        </Card>
      ))}
    </div>
  );
}
